// AUTO-GENERATED FILE - do not edit. Regenerated by scripts/generate-build-info.js.
export const BUILD_INFO = {
  gitSha: '4725a47489276b3cdd53bdbe1396be83d7dff744',
  gitShaShort: '4725a474',
  gitBranch: 'refs/tags/release-2.6.10.2.8',
  gitTag: 'release-2.6.10.2.8',
  buildTime: '2026-11-04T18:13:00.289Z',
} as const;
